module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEpSURBVHgBrdM/isJAFAbw7yUeIOV26xFisbALW7hH2Buk3G6xEGztRAXxBMYbeANtRMHCeIOAF8gBouN70YSJKDpjviZh3suP+ZMhWCT4aPuoYcSvTRAiKOqGq/5Mai4Mc8bUHKA3QK0BR55/jffvONovd2SJASl+ws0gCj47ddCRx1Sdx3+fBm9hRS1D0y3XYscQ83i/xjomCde9mGsy5j+cYWlmoESWRg4Fk2V/Wu6BzDAik2XCdZN8v3L0uoeexfJllg6Bfxd+/9d7yAQr6qWTRaL3OKZYlsPBA47eNSYhU+xRD1WJFWBVWAZWiUlq3DjJbkCKxqvYGQT5fPyLcDN8GZPcvcs22F3QFpNQ8NVWkB8U0D5Svg0mkT2ML1eoqY0vGGuZYpITYjftWv0OhPkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sidebar-icons/notes-active.png
// module id = 8z35
// module chunks = 37